import * as constants from './constants';

export const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const barcodeCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_BARCODE_CATEGORIES:
    return { ...state, loading: true };
  case constants.GET_BARCODE_CATEGORIES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_BARCODE_CATEGORIES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_BARCODE_CATEGORIES:
    return initialState;
  default:
    return state;
  }
};

export const initialUserBarcodeCategoriesState = {
  loading: false,
  data: [],
  error: null,
};

export const userBarcodeCategoriesReducer = (state = initialUserBarcodeCategoriesState, action) => {
  switch (action.type) {
  case constants.GET_USER_BARCODE_CATEGORIES:
    return { ...state, loading: true };
  case constants.GET_USER_BARCODE_CATEGORIES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_USER_BARCODE_CATEGORIES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_USER_BARCODE_CATEGORIES:
    return initialUserBarcodeCategoriesState;
  default:
    return state;
  }
};
